// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3MXy6","notes":"Notes_notes__1P7gv"};